export default __webpack_public_path__ + "static/media/learn_banner.0bb16f38.png";